import { useEffect } from 'react';

import { useRealTime } from './realTime.context';

import { MessagePayload, MessageType, PayloadByType } from './types';

export function useRealTimeSubscription<Type extends MessageType>(
  type: Type | null,
  handler: (message: PayloadByType[Type]) => void,
): void {
  const { registerHandler, unregisterHandler } = useRealTime();

  useEffect(() => {
    if (!type) return;

    const id = registerHandler(type, handler as (m: MessagePayload) => void);

    return () => {
      unregisterHandler(type, id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, handler]);
}
